if (typeof NoShippingAvailablity !== "function") {
  class NoShippingAvailablity extends HTMLElement {
    constructor() {
      super();

      // Create shipping indicator element
      const noShippingIndicator = document.createElement("div");
      noShippingIndicator.classList.add("alert");
      noShippingIndicator.classList.add("alert--circle");
      noShippingIndicator.classList.add("alert--error");
      noShippingIndicator.style.marginBottom = "0px"; // Set the bottom margin to 0px
      noShippingIndicator.innerHTML =
        "Shipping NOT Available for Spirits or Beer";

      // Append the shippingIndicator to the custom element
      this.appendChild(noShippingIndicator);
    }
  }

  if (typeof customElements.get("no-hipping-availability") === "undefined") {
    customElements.define("no-shipping-availability", NoShippingAvailablity);
  }
}
